var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"col col-4"},[(_vm.calculators)?_c('Calculators'):(_vm.articles)?_c('Articles'):_c('FAQ')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }